module.exports = __webpack_public_path__ + "static/media/pescados.d27144a0.jpg";